import React from "react"
import styles from "./FactorsToConsider.module.css"
import FactorsData from "./FactorsToConsider.json"
interface BulletItem {
  title: string
  description: string
}

const bulletData: BulletItem[] = FactorsData;

const FactorsToConsider = () => {
  return (
    <section className={styles.Container}>
      
      {/* Inner wrapper for center alignment */}
      <div className={styles.InnerWrapper}>
        
        {/* Title */}
        <h2 className={styles.Title}>
        Factors to consider when planning for your child’s education
        </h2>

        {/* Description */}
        <p className={styles.Description}>
        Below are some factors to consider when planning for your child’s education needs:
        </p>

        {/* Card */}
        <div className={styles.Card}>
          {bulletData.map((item, index) => (
            <div key={index} className={styles.BulletItem}>
              
              {/* Title with bullet */}
              <h3 className={styles.BulletTitle}>
                <span className={styles.BulletIcon}></span>
                {item.title}
              </h3>

              {/* Description */}
              <p className={styles.BulletDescription}>
                {item.description}
              </p>

            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

export default FactorsToConsider